export default __webpack_public_path__ + "static/media/img-private.06325868.jpg";